import { render, staticRenderFns } from "./electric-move.vue?vue&type=template&id=aa1a47a4&scoped=true&"
import script from "./electric-move.vue?vue&type=script&lang=js&"
export * from "./electric-move.vue?vue&type=script&lang=js&"
import style0 from "./electric-move.vue?vue&type=style&index=0&id=aa1a47a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1a47a4",
  null
  
)

export default component.exports